module.exports = __webpack_public_path__ + "img/administrative-burden.e0ca71fa.jpg";